import { Controller } from '@hotwired/stimulus';
import { featureEnabled } from 'lib/helpers';
import { buildPlanItems } from 'lib/plan-helpers';
import { sendTrackingEvent, trackCompleteEvent, findCategoryByElement } from 'components/analytics/conversions/tracking';
import { CART_ABANDON_BANNER_TRIGGERED, CART_ABANDON_BANNER_COMPLETE, EC_PLAN_SELECTION } from 'components/analytics/conversions/constants/actions';
import Cookies from 'js-cookie';

export default class SiteBannerController extends Controller {
  static values = {
    slug: String,
    dismissExpires: Number,
    cookie: String,
    plan: Object,
  }

  connect() {
    this.setupSessionBanner();

    if (featureEnabled('annual_cart_abandonment') && this.cookieValue) {
      sendTrackingEvent({
        element: this.element,
        data: {
          action: CART_ABANDON_BANNER_TRIGGERED,
          label: 'Plan-Unlimited Annual Universal',
          non_interaction: true,
        },
      });
    }

    document.body.classList.add('has-bottom-banner');
  }

  trackDiscount() {
    if (!featureEnabled('annual_cart_abandonment')) return;

    const builtPlan = buildPlanItems({ plans: [this.planValue] });

    sendTrackingEvent({
      data: {
        action: EC_PLAN_SELECTION,
        items: builtPlan,
      },
    });

    trackCompleteEvent({
      action: CART_ABANDON_BANNER_COMPLETE,
      category: findCategoryByElement(this.element),
      label: 'Plan-Unlimited Annual Universal',
    });
  }

  dismiss = (event) => {
    event.preventDefault();
    event.stopPropagation();

    this.setDismissedCookie();
    document.body.classList.remove('has-bottom-banner');

    this.element.remove();
  }

  setDismissedCookie() {
    if (this.cookieValue === 'annual_cart_abandonment') return;

    const cookieOptions = this.hasDismissExpiresValue
      ? { domain: this.cookieDomain, expires: this.dismissExpiresValue }
      : { domain: this.cookieDomain };

    if (!this.element.dataset.dismissSessionId) {
      Cookies.set(
        `${this.slugValue}_banner_dismissed`, 'internal', cookieOptions,
      );
    }
  }

  get cookieDomain() {
    const cookieDomainArray = window.location.hostname.split('.');
    return `${cookieDomainArray[1]}.${cookieDomainArray[2]}`;
  }

  setupSessionBanner() {
    const sessionId = this.element.dataset.dismissSessionId;
    if (sessionId && sessionStorage.getItem(sessionId) !== '1') {
      this.element.classList.remove('is-hidden');
    }
  }

  setSessionCookie() {
    const sessionId = this.element.dataset.dismissSessionId;
    sessionStorage.setItem(sessionId, '1');
  }

  removeBannerCookie() {
    Cookies.remove(this.cookieValue);
  }
}
